























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class DateInput extends Vue {
  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: String, default: '' })
  width!: string

  @Prop({ type: String, default: 'date' })
  type!: string

  @Prop({ type: String, default: '' })
  label!: string

  get inputValue() {
    return this.value
  }
  set inputValue(newText: string) {
    this.$emit('input', newText)
    this.$nextTick(() => this.$emit('change'))
  }

  @Prop({ type: Function, default: () => true })
  validator!: (answer: string) => boolean

  get valid() {
    return this.validator(this.inputValue)
  }

  get required() {
    return !this.validator('')
  }
}
